export const theme = {
    colors: {
        primaryBg: "#ffffff",
        secondaryBg: "#1A1A1A",
        accent: "#333333",
        font: "#F4F4F4"
    }
}

